import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listDocumentos:[],
  listTipoDocumentos:[],
  listEspecialidad:[],
  listSolicitudes:[],
};
export const mutations = {

  SOLICITUD({ context }, listSolicitudes) {
    state.loading = false;
    if (listSolicitudes) {
      let solicitudes = [];
      Object.entries(listSolicitudes).forEach(([key, val]) => solicitudes.push(val));
      return (state.listSolicitudes = solicitudes);
    }
  },

  GET_TIPO_DOCUMENTOS({ context }, listTipoDocumentos) {
    state.loading = false;
    if (listTipoDocumentos) {
      let documentos = [];
      Object.entries(listTipoDocumentos).forEach(([key, val]) => documentos.push(val));
      return (state.listTipoDocumentos = documentos);
    }
  },

  GET_ESPECIALIDADES({ context }, listEspecialidad) {
    state.loading = false;
    if (listEspecialidad) {
      let especialidades = [];
      Object.entries(listEspecialidad).forEach(([key, val]) => especialidades.push(val));
      return (state.listEspecialidad = especialidades);
    }
  },
  GET_FILE({ context }, data) {
    state.resultDocument = Object.assign({}, data);
  },
};
export const actions = {
  SOLICITUD({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // console.log(response.data.data.solicitudes);
          commit("SET_LOADING", false);
          commit("SOLICITUD", response.data.data.solicitudes);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_TIPO_DOCUMENTOS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // console.log(response.data.data);
          commit("SET_LOADING", false);
          commit("GET_TIPO_DOCUMENTOS", response.data.data.tipo_documentos);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GUARDAR_ARCHIVO({ commit }, dataArchivo) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      // console.log(dataArchivo);
      ApiService.post(dataArchivo)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          // commit("GUARDAR_ARCHIVO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_FILE({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      // console.log(data);
      ApiService.getFile(data)
        .then(response => {
          // console.log(response.data);
          commit("SET_LOADING", false);
          commit("GET_FILE", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  DELETE_FILE({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      // console.log(data);
      ApiService.deleteFile(data)
        .then(response => {
          // console.log(response.data);
          commit("SET_LOADING", false);
          // commit("DELETE_FILE", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_ESPECIALIDADES({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // console.log(response.data.data);
          commit("SET_LOADING", false);
          commit("GET_ESPECIALIDADES", response.data.data.especialidades);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

};

export const getters = {//leer datos
  listDocumentos: state => state.listDocumentos,
  listTipoDocumentos: state => state.listTipoDocumentos,
  listEspecialidad: state => state.listEspecialidad,
  listSolicitudes: state => state.listSolicitudes,
};
